/**
 * Hard navigation back to /login after the session is actually gone.
 *
 * Used by both axios instances.  A module-level latch stops a burst of
 * 401s from stacking location.replace calls (which looked like a
 * /login ↔ /task flicker every second).
 */
import { isPublicRoute, ROUTES, safeInternalNext } from '../config';
import { isLoginRoute } from './authHandshake';
import { clearLocalAuth } from './authStorage';

let redirecting = false;

export function resetLoginRedirectLatch() {
  redirecting = false;
}

export function redirectToLogin() {
  if (typeof window === 'undefined' || redirecting) return;
  const path = window.location.pathname || '';
  if (isLoginRoute(path)) return;
  if (ROUTES.SIGNUP && (path === ROUTES.SIGNUP || path.startsWith(`${ROUTES.SIGNUP}/`))) {
    return;
  }
  if (isPublicRoute(path)) return;

  redirecting = true;
  clearLocalAuth();

  if (path.startsWith('/complaints') && !path.startsWith('/complaints/sso/login')) {
    window.location.replace('/complaints');
    return;
  }

  const next = safeInternalNext(`${path}${window.location.search || ''}`);
  const target = next
    ? `${ROUTES.LOGIN}?next=${encodeURIComponent(next)}`
    : ROUTES.LOGIN;
  window.location.replace(target);
}
